
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import classNames from 'classnames/bind';
import JobList from 'components/recruit/jobs/JobList';
import JobNotice from 'components/recruit/jobs/JobNotice';
import RecruitBanner from 'components/recruit/RecruitBanner';
import SITE_META from 'constants/siteMeta';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { useRouter } from 'next/router';
import styles from 'styles/Recruit.module.css';
import { toLocale } from 'utils/locale';
const cx = classNames.bind(styles);
function RecruitJobs() {
    const { t } = useTranslation('recruit-jobs');
    const { t: rt } = useTranslation('recruit');
    const { locale } = useRouter();
    return (<div className={cx('recruit', 'ja-break')}>
      <Head>
        <title>{`${rt('nav-jobs')} | ${SITE_META[toLocale(locale)].siteName}`}</title>
      </Head>
      <RecruitBanner image="/images/recruit/banner-jobs.png" title={t('banner-title')} description={t('banner-description')}/>
      <div className={cx('content')}>
        <div className={cx('content-inner')}>
          <JobList />
          <JobNotice />
        </div>
      </div>
    </div>);
}
export default RecruitJobs;

    async function __Next_Translate__getStaticProps__1a181b9348c__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/career/jobs/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a181b9348c__ as getStaticProps }
  